import {
  getRelativeFontSize,
  inputLabelRequiredColor,
  mediumFont,
  regularFont,
  theme,
} from "../../../utils/styles";

const dataDownloadStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 184px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    my: 3,
    maxWidth: "1750px",
    width: "100%",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 204px)",
    },
    [theme.breakpoints.down("md")]: {
      my: 2,
      height: "calc(100vh - 209px)",
    },
    [theme.breakpoints.down("sm")]: {
      my: 3,
    },
  },
  subBox: {
    p: 3,
    pt: 1.5,
    height: "calc(100vh - 222px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 242px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 247px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 229px)",
      p: 1,
    },
  },
  scrollStyle: {
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 220px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 235px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 222px)",
    },
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "45px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "35px",
    },
  },
  tableLinkText: {
    ...regularFont,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "350px",
    color: "#ffffff",
    fontSize: "16px",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      // textDecoration: "underline",
      opacity: 0.8,
    },
    display: "inline-block",
  },
  modalHeader: {
    ...regularFont,
    fontSize: getRelativeFontSize(10),
    color: "#222222",
    textAlign: "center",
  },
  textField: {
    width: "100%",
    background: "transparent",
    borderRadius: "10px",
    backgroundClip: "content-box,border-box",
    backgroundImage:
      "linear-gradient(#ffffff,#ffffff),linear-gradient(90deg,#DF66E3 -0.11%,#5E75FF 55.68%, #2CF1DF 100.01%)",
    backgroundOrigin: "border-box",
    border: "double 2px transparent",

    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },

    "& .MuiSelect-outlined": {
      border: "none",
      position: "relative",
      padding: "12px 12px",
      color: "#000000",

      "&::placeholder": {
        ...mediumFont,
        color: "##000000de",
      },
    },
    "& .MuiSelect-icon": {
      color: "#000000",
    },
    "& ..MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      borderColor: "#ffffff",
      "&.Mui-focused fieldset": {
        borderColor: "#ffffff",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px",
    },
  },
  nameField: {
    color: "#000000",
    "& .MuiFormLabel-asterisk": {
      color: inputLabelRequiredColor,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
  errorStyle: {
    fontSize: "11px",
    marginLeft: "6px",
    color: "#d32f2f",
  },
  autoCompleteWrapper: {
    display: "flex",
    gap: 3,
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
  },
  autoComplete: {
    flex: 1,
    maxWidth: "300px",
    "& .MuiAutocomplete-input": {
      color: "#FFFFFF",
    },
    "& .MuiInputBase-root": {
      borderRadius: "10px",
      background: "rgba(255, 255, 255, 0.05)",
      backdropFilter: "blur(5.5px)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      transition: "border-color 0.2s ease",
      "&:hover": {
        borderColor: "rgba(255, 255, 255, 0.3)",
      },
      "&.Mui-focused": {
        borderColor: "rgba(255, 255, 255, 0.4)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiAutocomplete-endAdornment": {
      "& .MuiSvgIcon-root": {
        color: "#FFFFFF",
      },
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "#FFFFFF",
    },
  },
  autoCompleteLabel: {
    color: "#FFFFFF",
    opacity: 0.7,
    marginBottom: "8px",
    fontSize: "14px",
  },
} as const;

export default dataDownloadStyles;
